wbApp.controller('UsersConsentsDetailCtrl', ['$scope', '$modal', '$translate', 'consentSvc',
function ($scope, $modal, $translate, consentSvc) {

    $scope.userConsentsDetails = [];

    $scope.$on('userConsentSelectionChanged', function (e, newlySelectedUser) {
        $scope.userConsentsDetails.length = 0;
        if (newlySelectedUser) {
            consentSvc.getConsentsInfoForUser(newlySelectedUser.userID).$promise.then(
                function (data) {
                    $scope.userConsentsDetails.push.apply($scope.userConsentsDetails, data.consents);
                });
        }
    });

    $scope.userConsentsDetailGridSettings = {
        name: 'userConsentsDetail',
        columns: [
            { dataField: 'consentName', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', sortOrder: 'asc', width: '130px' },
            { dataField: 'consentText', caption: $translate.instant('TXT_LBL_TEXT'), dataType: 'string' },

            { dataField: 'consentRatifiedAt', caption: $translate.instant('TXT_APPROVED_AT'), dataType: 'date', width: '90px' },
            { dataField: 'consentRevokedAt', caption: $translate.instant('TXT_DENIED_AT'), dataType: 'date', width: '90px' },

            { dataField: 'validFrom', caption: $translate.instant('TXT_LAB_VALID_FROM'), dataType: 'date', width: '90px' },
            { dataField: 'validTo', caption: $translate.instant('TXT_LAB_VALID_TO'), dataType: 'date', width: '90px' },
        ],
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (!!data.consentRevokedAt) {
                    e.rowElement.addClass('text-danger');
                }
                else if (!!data.consentRatifiedAt) {
                    e.rowElement.addClass('text-success');
                }
            }
        }
    }

}]);
